<template>
  <CatalogCrudView
    title="Entidades financeiras"
    subtitle="Cadastre as partes que participam das obrigações, pagamentos e movimentações financeiras."
    singular="entidade financeira"
    new-label="Nova entidade financeira"
    list-title="Entidades cadastradas"
    icon="building"
    search-placeholder="Tipo, nome, documento ou e-mail"
    :service="service"
    :fields="fields"
    :columns="columns"
    :form-defaults="formDefaults"
  />
</template>

<script>
import Swal from 'sweetalert2'
import CatalogCrudView from '../components/CatalogCrudView.vue'
import service from '../services/financialEntityService'

export default {
  name: 'FinancialEntitiesView',
  components: { CatalogCrudView },
  data: () => ({
    service,
    typeOptions: [{ value: 0, label: 'Selecione o tipo', disabled: true }],
    formDefaults: { typeId: 0, name: '', tradeName: '', documentNumber: '', email: '', isActive: true },
    columns: [
      { text: 'Id', value: 'id' }, { text: 'Tipo', value: 'typeName' },
      { text: 'Nome oficial', value: 'name', emphasis: true }, { text: 'Nome fantasia', value: 'tradeName' },
      { text: 'Documento', value: 'documentNumber' }, { text: 'E-mail', value: 'email' },
      { text: 'Situação', value: 'isActive', type: 'status' }, { text: 'Criado em', value: 'createdAt', type: 'date' }
    ]
  }),
  computed: {
    fields () {
      return [
        { key: 'typeId', label: 'Tipo de entidade', required: true, type: 'select', options: this.typeOptions, span: 3 },
        { key: 'name', label: 'Nome oficial', required: true, maxlength: 200, placeholder: 'Razão social ou nome completo', span: 5 },
        { key: 'tradeName', label: 'Nome fantasia', maxlength: 200, placeholder: 'Nome comercial', span: 4 },
        { key: 'documentNumber', label: 'CPF/CNPJ ou documento', maxlength: 30, placeholder: 'Somente quando aplicável', span: 3 },
        { key: 'email', label: 'E-mail', type: 'email', maxlength: 150, placeholder: 'contato@empresa.com.br', span: 7 },
        { key: 'isActive', label: 'Situação', type: 'select', options: [{ value: true, label: 'Ativo' }, { value: false, label: 'Inativo' }], span: 2 }
      ]
    }
  },
  created () {
    this.loadTypeOptions()
  },
  methods: {
    async loadTypeOptions () {
      try {
        const options = await service.getEntityTypeOptions()
        this.typeOptions = [
          { value: 0, label: 'Selecione o tipo', disabled: true },
          ...options.map(option => ({
            value: option.id,
            label: option.isActive ? option.name : `${option.name} (inativo)`,
            disabled: !option.isActive
          }))
        ]
      } catch (_) {
        await Swal.fire({ title: 'Atenção', text: 'Não foi possível carregar os tipos de entidade.', icon: 'error', confirmButtonColor: '#e77900' })
      }
    }
  }
}
</script>
